import { useOrgLiveTransfersGQL } from '../graphql/dashboard/useOrgLiveTransfersGQL';

interface DateRange {
  from: Date | null;
  to: Date | null;
}

interface LiveTransfersStats {
  count: number;
  isLoading: boolean;
  error: Error | null;
}

export const useLiveTransfersCount = (dateRange: DateRange) => {
  const enabled = Boolean(dateRange.from && dateRange.to);
  const { total, isLoading } = useOrgLiveTransfersGQL({
    dateRange,
    enabled,
    pageSize: 1,
  });

  return {
    count: enabled ? total : 0,
    isLoading: enabled ? isLoading : false,
    error: null,
  } satisfies LiveTransfersStats;
};
